import {
  ActionIcon,
  Box,
  Button,
  FileButton,
  Group,
  Image,
  NumberInput,
  Paper,
  SimpleGrid,
  Stack,
  Text,
} from '@mantine/core'
import { IconPhotoPlus, IconTrash } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'

export function AssetField({
  field,
  value,
  onChange,
  error,
  addAsset,
  assetUrls,
}) {
  const { t } = useTranslation()
  const previewUrl = value ? assetUrls[value] : null

  return (
    <Stack gap={6}>
      <Text size="sm" fw={500}>{field.label}</Text>
      <Paper withBorder radius="md" p="sm">
        {previewUrl ? (
          <Group wrap="nowrap" align="center">
            <Image src={previewUrl} alt="" w={86} h={64} fit="contain" radius="sm" bg="gray.0" />
            <Box style={{ flex: 1, minWidth: 0 }}>
              <Text size="xs" c="dimmed" truncate>{t('editorV2.form.fields.selectedImage')}</Text>
              <FileButton
                accept="image/png,image/jpeg,image/webp,image/gif,image/svg+xml,image/x-icon"
                onChange={(file) => {
                  const id = addAsset(file)
                  if (id) onChange(id)
                }}
              >
                {(props) => <Button {...props} mt={5} size="xs" variant="light">{t('editorV2.form.common.replace')}</Button>}
              </FileButton>
            </Box>
            <ActionIcon
              color="red"
              variant="light"
              aria-label={t('editorV2.form.common.removeLabel', { label: field.label })}
              onClick={() => onChange(null)}
            >
              <IconTrash size={16} />
            </ActionIcon>
          </Group>
        ) : (
          <FileButton
            accept="image/png,image/jpeg,image/webp,image/gif,image/svg+xml,image/x-icon"
            onChange={(file) => {
              const id = addAsset(file)
              if (id) onChange(id)
            }}
          >
            {(props) => (
              <Button {...props} fullWidth size="xs" variant="light" leftSection={<IconPhotoPlus size={16} />}>
                {t('editorV2.form.fields.uploadImage')}
              </Button>
            )}
          </FileButton>
        )}
      </Paper>
      {field.help && <Text size="xs" c="dimmed">{field.help}</Text>}
      {error && <Text size="xs" c="red">{error}</Text>}
    </Stack>
  )
}

export function FocalPointField({ field, value, onChange, error }) {
  const { t } = useTranslation()
  const focal = value || { x: 50, y: 50 }
  return (
    <Stack gap={6}>
      <Text size="sm" fw={500}>{field.label}</Text>
      <SimpleGrid cols={2}>
        <NumberInput
          label={t('editorV2.form.fields.horizontal')}
          value={Number(focal.x ?? 50)}
          min={0}
          max={100}
          suffix="%"
          size="xs"
          onChange={(x) => onChange({ ...focal, x: Number(x || 0) })}
        />
        <NumberInput
          label={t('editorV2.form.fields.vertical')}
          value={Number(focal.y ?? 50)}
          min={0}
          max={100}
          suffix="%"
          size="xs"
          onChange={(y) => onChange({ ...focal, y: Number(y || 0) })}
        />
      </SimpleGrid>
      {error && <Text size="xs" c="red">{error}</Text>}
    </Stack>
  )
}

export const assetFieldRegistry = {
  image: AssetField,
  'focal-point': FocalPointField,
}
